var config = {
  CPU_LOST_ENERGY: 0.5
};

module.exports = config;
